import { Stack } from "@mui/material";
import { PopperStyled, popperClasses } from "./styles";

interface IMenuPopperProps {
  anchor: HTMLElement | null;
  children;
}

export const MenuPopper = ({ anchor, children }: IMenuPopperProps) => {
  return (
    <PopperStyled
      className={popperClasses.root}
      open={Boolean(anchor)}
      anchorEl={anchor}
      placement="right-start"
      modifiers={[{ name: "offset", options: { offset: [16, -8] } }]}
    >
      <Stack className={popperClasses.root}>{children}</Stack>
    </PopperStyled>
  );
};
